<template>
  <el-dialog title="装车确认" :visible.sync="confirmVisibleThree" :close-on-click-modal="false" width="80%" center
    :before-close="closeadd">
    <div class="top" style="font-size:16px;margin-bottom:10px;margin-left:10px;">
      车号：<span>{{ tEmptyOutstockMaster.outstockPlateNumber }}</span>
    </div>
    <hr>
    <div style="margin:20px 0 30px 0;" v-for="(item, ix) in allDataList" :key="ix">
      <div>
        <div style="display: flex;justify-content: space-between;">
          <div style="display: flex;margin-bottom:10px;">
            <div>{{ (item.cargoControlKey).replace(/,/g, "/") }}</div>
            <div style="display: flex;">
              <span style="margin-left:20px;">总重量：</span>
              <div>
                <span style="color:red">{{ item.sumWeight }}</span><span> 吨 </span>
                <span> / </span><span style="color:red">{{ item.num }}</span><span> 件</span>
              </div>
            </div>
            <div style="display: flex;" v-if="item.cargoControlKey != '不控货'">
              <span style="margin-left:20px;" v-if='item.controlWeight == 1 || item.controlPiece == 1'>未提量：</span>
              <div>
                <span v-if='item.controlWeight == 1'><span style="color:red">{{ item.controlStockWeight
                }}</span><span>
                    吨</span></span>
                <span v-if='item.controlPiece == 1'><span> / </span><span style="color:red">{{ item.controlStockNumber
                }}</span><span> 件</span></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <el-table max-height="300px" border bordersize="mini" size="mini" ref="tabref" :data="item.list" style="width:100%"
        highlight-current-row :header-cell-style="{ background: '#F5F5F5', color: 'black' }"
        :header-cell-class-name="Add">
        <el-table-column type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
        <el-table-column prop="number" align="center" label="件数" width="">
          <template slot-scope="scope1">
            <el-input v-model="scope1.row.number" @input="changeJianShu(scope1.row, scope1.row.number)"
              v-number-input.float="0" maxlength="50" placeholder="请输入件数" size="mini"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="weight" align="center" label="理重（吨）" width="">
          <template slot-scope="scope1">
            <el-input v-model="scope1.row.weight" v-number-input.float="3" maxlength="50" placeholder="请输入重量" size="mini"
              :disabled="true" @blur="weightInput(scope1.row, scope1.row.weight)"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="weighingWeight" align="center" label="过磅净重（吨）" width="150">
          <template slot-scope="scope1">
            <el-input v-model="scope1.row.weighingWeight" v-number-input.float="3" maxlength="50" placeholder="请输入过磅净重"
              size="mini" @blur="weighingWeight(scope1.row, scope1.row.weighingWeight)"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="warehouseId" align="center" label="仓位">
          <template slot-scope="scope1">
            <el-select clearable filterable @change="changeCangWei(scope1.row, scope1.row.warehouseId)"
              v-model="scope1.row.warehouseId" size="mini" placeholder="请选择仓位">
              <el-option v-for="(item, index) in scope1.row.tEmptyStockWarehouseList" :key="index"
                :label="item.warehouseName" :value="item.warehouseId"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="locationId" label="区位">
          <template slot-scope="scope1">
            <el-select clearable filterable v-model="scope1.row.locationId" size="mini" placeholder="请选择区位"
              @change="changeLocation(scope1.row, scope1.row.locationId)">
              <el-option v-for="(item, index) in scope1.row.QuWeiData" :key="index" :label="item.locationName"
                :value="item.locationId"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="sceneUser" align="center" label="现场人员">
          <template slot-scope="scope1">
            <el-select clearable filterable v-model="scope1.row.sceneUser" @change="sceneUserChange(scope1.row)"
              size="mini" placeholder="请选择">
              <el-option v-for="(item, index) in RYData" :key="index" :label="item.userName" :value="item.userName">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="waAvNumber" align="center" label="仓位可提件数" width="150">
          <!-- <template slot-scope="scope1">
            <el-input :disabled="true" v-model="scope1.row.waAvNumber" maxlength="50" placeholder="请输入"
              size="mini"></el-input>
          </template> -->
        </el-table-column>
        <el-table-column prop="placeOfOrigin" align="center" label="产地" width=""></el-table-column>
        <el-table-column prop="productTypeName" align="center" label="货物类型" width=""></el-table-column>
        <el-table-column prop="specification" align="center" label="规格" width=""></el-table-column>
        <el-table-column prop="model" align="center" label="材质" width=""></el-table-column>
        <!-- <el-table-column prop="model" align="center" label="出厂过磅净重(吨)"  width=""></el-table-column> -->
      </el-table>
    </div>
    <div slot="footer" style="text-align:center;margin:15px;">
      <el-button @click="closeadd">取 消</el-button>
      <el-button type="primary" :loading="confirmLoading" @click="confirmClick(1)">确认装车</el-button>
      <!-- <el-button type="primary" :loading="confirmLoadingDY" @click="confirmClick(2)">确认出库并打印</el-button> -->
    </div>
  </el-dialog>
</template>

<script>
import {
  JfgetOutstockInfoJanFaForConfirm, // 查询出库单主表子表所有信息（打印、修改回显、确认出库回显用）
  confirmWhOutstockJanFaChuCang, // 出库计划页面  出仓提单创建的出库计划 确认出库
  JfgetNumberForBillStockWarehouse,
  zidianQuwei,
  virtualControlBeanZy,
  getEmptyBillStockLocationInfo,
  cVirtualControlList, // 控货剩余
  getUsersByTenantCode // 取得出仓提单创建的出库计划 确认出库 货物信息未提量
} from '@/api/wms-stock'
import {
  updateTOutstockSummaryZyControl
} from '@/api/wms-access'
// import { dateFormat1 } from '@/utils/util.js'
export default {
  name: 'xieCheDialog',
  data () {
    return {
      RYData: [],
      confirmLoading: false,
      selectSijiVisible: false,
      TableIndex: 0,
      weightEnd: 0,
      khFlag: false,
      hasValidFlag: true,
      disLocation: true,
      emptyBillType: '',
      controlStockWeight: 0,
      controlStockNumber: 0,
      billNo: '',
      marsterData1: {},
      addBtnShow: false,
      allDataList: [],
      QuWeiData: [],
      qwData: [],

      noBillId: false,
      plateNumberOption: [],
      tEmptyOutstockMaster: {},
      confirmLoadingDY: false,
      checkFlag: true,
      parentData: {},
      weiTiData: {},
      goodArr: []
    }
  },
  props: {
    confirmVisibleThree: {
      type: Boolean,
      default: false
    },
    outstockId: {
      type: Number
    },
    deliveryObj: {
      type: Object
    },
    marsterData: {
      type: Object
    }
  },
  watch: {
    deliveryObj: {
      deep: true,
      immediate: true,
      handler (val) {
        if (val) {
          this.parentData = val
        }
      }
    },
    marsterData: {
      deep: true,
      immediate: true,
      handler (val) {
        if (val) {
          this.marsterData1 = val
        }
      }
    }
  },
  async created () {
    await this.getUsersByTenantCodes()

    await this.getOutstockInfoJanFa()
  },
  methods: {
    sceneUserChange (row) {
      console.log(row)
      this.$set(row, 'sceneUserId', this.RYData.filter(item => item.userName == row.sceneUser)[0].userCode)
    },
    // 现场人员
    getUsersByTenantCodes () {
      getUsersByTenantCode()
        .then(res => {
          console.log(res)
          this.RYData = res
        })
        .catch(error => {
          this.$message.error(error.message)
        })
    },
    // 小星星
    Add (obj) {
      if (obj.column.property == 'number' || obj.column.property == 'warehouseId' || obj.column.property == 'locationId') {
        return 'star'
      }
    },
    closeadd () {
      this.$emit('update:confirmVisibleThree', false)
    },
    changeJianShu (row, val) {
      if (val) {
        this.$set(row, 'weight', (row.number / 1 * row.singletonWeight).toFixed(3))
        if (row.flag == '理重') {
          this.$set(row, 'allWeight', (row.number / 1 * row.singletonWeight).toFixed(3))
        } else {
          this.$set(row, 'allWeight', (row.weighingWeight / 1).toFixed(3))
        }
      } else {
        this.$set(row, 'weight', '0.000')
        this.$set(row, 'allWeight', '0.000')
        this.$message.error('发货件数不能为空')
      }
      this.allDataList.forEach((item, index) => {
        this.$set(item, 'num', item.list.reduce((pre, cur) => {
          return pre / 1 + cur.number / 1
        }, 0))
        this.$set(item, 'sumWeight', (item.list.reduce((pre, cur) => {
          return pre / 1 + cur.allWeight / 1
        }, 0)).toFixed(3))
      })
    },
    weightInput (row, val) {
      if (row.flag == '理重') {
        this.$set(row, 'allWeight', (row.number / 1 * row.singletonWeight).toFixed(3))
      } else {
        this.$set(row, 'allWeight', (row.weighingWeight / 1).toFixed(3))
      }
      row.weight = Number(val).toFixed(3)
      this.allDataList.forEach((item, index) => {
        this.$set(item, 'num', item.list.reduce((pre, cur) => {
          return pre / 1 + cur.number / 1
        }, 0))
        this.$set(item, 'sumWeight', (item.list.reduce((pre, cur) => {
          return pre / 1 + cur.allWeight / 1
        }, 0)).toFixed(3))
      })
    },
    // 过磅净重
    weighingWeight (row, val) {
      // weighingWeight（过磅净重（吨）  出库计重方式为磅重的时候必填 ）
      // allWeight（总重量（吨）  必填 出库计重方式为理重的时候=理重（吨）、出库计重方式为磅重的时候=过磅净重（吨））
      row.weighingWeight = Number(row.weighingWeight).toFixed(3)
      if (row.flag == '理重') {
        this.$set(row, 'allWeight', (row.number / 1 * row.singletonWeight).toFixed(3))
      } else {
        this.$set(row, 'allWeight', (row.weighingWeight / 1).toFixed(3))
      }
      this.allDataList.forEach((item, index) => {
        // this.$set(item, 'num', item.list.reduce((pre, cur) => { return pre / 1 + cur.number / 1 }, 0))
        this.$set(item, 'sumWeight', (item.list.reduce((pre, cur) => {
          return pre / 1 + cur.allWeight / 1
        }, 0)).toFixed(3))
      })
    },
    changeLocation (row, val) {
      console.log(row, 'row')
      console.log(val, 'val')
      let choosenItem = row.QuWeiData.filter(
        item => item.locationId == val
      )[0]
      console.log(choosenItem, 'choosenItem')
      this.$set(row, 'locationName', choosenItem.locationName)
      this.$set(row, 'stockWarehouseId', choosenItem.stockWarehouseId)

      JfgetNumberForBillStockWarehouse({
        stockWarehouseId: choosenItem.stockWarehouseId
      }).then(res => {
        this.$set(row, 'waAvNumber', res.whAvailableNumber)
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    changeCangWei (row, val) {
      console.log(row, 'row.111')
      let that = this
      that.disLocation = false
      getEmptyBillStockLocationInfo({
        warehouseId: row.warehouseId,
        model: row.model,
        productType: row.productType,
        specification: row.specification,
        steelMillName: row.placeOfOrigin
      })
        .then(res => {
          row.QuWeiData = []

          if (res.length !== 0) {
            res.forEach((item, index) => {
              if (!item.locationId) {
                item.locationName = '无'
              }
              let arr = { locationName: item.locationName, locationId: item.locationId, stockWarehouseId: item.stockWarehouseId }
              row.QuWeiData.push(arr)
            })
          }
          const uniqueArr = []

          row.QuWeiData.forEach(item => {
            if (!uniqueArr.some(i => i.locationId === item.locationId)) {
              uniqueArr.push(item)
            }
          })
          console.log(uniqueArr, 'uniqueArr')
          this.$set(row, 'QuWeiData', uniqueArr)

          console.log(that.allDataList, 'that.allDataList')
        })
        .catch(err => {
          that.$message({
            message: err.message,
            type: 'error'
          })
        })
      row.tEmptyStockWarehouseList.forEach((item, index) => {
        if (val == item.warehouseId) {
          row.singletonWeight = item.singletonWeight
          row.warehouseName = item.warehouseName
          row.warehouseId = item.warehouseId

          that.$set(row, 'locationId', '')
          console.log(row, 'row')
        }
      })
    },
    // 获取数据
    getOutstockInfoJanFa () {
      JfgetOutstockInfoJanFaForConfirm({
        outstockId: this.outstockId
      }).then(res => {
        this.cVirtualControlList()

        this.getData(res)
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 控货剩余
    cVirtualControlList () {
      cVirtualControlList({
        oneCustomerTaxId: this.marsterData1.primaryCustomerTaxId,
        organizationId: localStorage.getItem('tenantCode'),
        pageNo: 1,
        pageSize: 20,
        twoCustomerTaxId: this.marsterData1.customerTaxId
      }).then(res => {
        if (res.list.length !== 0) {
          // 控货
          this.khFlag = false
          // controlStockWeight

          res.list.forEach(item => {
            this.controlStockWeight = item.controlStockWeight.toFixed(3)
          })
        } else {
          this.khFlag = true
        }
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    async getData (res) {
      this.tEmptyOutstockMaster = res.tEmptyOutstockMaster
      let tEmptyOutstockSummaryList = res.mapList

      if (tEmptyOutstockSummaryList.length != 0) {
        tEmptyOutstockSummaryList.forEach(item => {
          item.tEmptyOutstockSummary.waAvNumber = item.waAvNumber
        })
        let mapData = new Map()
        for (const item of tEmptyOutstockSummaryList) {
          let cargoControlKey = item.tEmptyOutstockSummary.cargoControlKey
          if (cargoControlKey == ',,,') {
            cargoControlKey = '总控'
          }
          item.tEmptyOutstockSummary.flag = item.flag
          let keyArr = cargoControlKey.split(',')
          console.log(item)
          if (item.flag == '理重') {
            item.tEmptyOutstockSummary.allWeight = item.tEmptyOutstockSummary.weight
          } else {
            item.tEmptyOutstockSummary.allWeight = item.tEmptyOutstockSummary.weighingWeight
          }

          if (mapData.has(cargoControlKey)) {
            let dataObj = mapData.get(cargoControlKey)
            // dataObj.sumWeight = sum
            if (item.flag == '理重') {
              dataObj.sumWeight += item.tEmptyOutstockSummary.weight
            } else {
              dataObj.sumWeight += item.tEmptyOutstockSummary.weighingWeight
            }
            // dataObj.sumWeight = (dataObj.sumWeight + item.tEmptyOutstockSummary.weight).toFixed(4)
            dataObj.num = dataObj.num + item.tEmptyOutstockSummary.number
            dataObj.releaseFlag = 0
            this.$set(item.tEmptyOutstockSummary, 'tEmptyStockWarehouseList', item.tEmptyStockWarehouseList)
            this.$set(item.tEmptyOutstockSummary, 'whNumber', item.whNumber)
            this.$set(item.tEmptyOutstockSummary, 'whWeight', item.whWeight)
            this.$set(item.tEmptyOutstockSummary, 'waAvNumber', item.waAvNumber)
            dataObj.list.push(item.tEmptyOutstockSummary)
          } else {
            let params = {
              oneCustomerTaxId: this.tEmptyOutstockMaster.primaryCustomerTaxId, // （一级货主纳税人识别号  必填）
              twoCustomerTaxId: this.tEmptyOutstockMaster.customerTaxId, // （二级货主纳税人识别号  必填）
              organizationId: this.tEmptyOutstockMaster.organizationId, // （仓储租户id  必填）
              productionPlaceName: keyArr[0], // （产地  必填）
              goodTypeName: keyArr[1], // （货物类型名称  必填
              specificationName: keyArr[2], // （规格  必填）
              materialName: keyArr[3] // （材质  必填）
            }
            let res = ''
            let isEnableObj = {}
            if (keyArr[0] != '不控货') {
              res = await virtualControlBeanZy(params)
            }
            if (res) {
              isEnableObj = JSON.parse(res)
            }
            console.log(isEnableObj, 'isEnableObj')
            let dataObj = {
              cargoControlKey: cargoControlKey,
              releaseFlag: 0,
              list: [],
              controlStockWeight: isEnableObj.controlStockWeight,
              controlStockNumber: isEnableObj.controlStockNumber,
              controlWeight: isEnableObj.controlWeight,
              controlPiece: isEnableObj.controlPiece,
              strictReminder: isEnableObj.strictReminder,
              isEnable: isEnableObj.isEnable,
              sumWeight: 0
            }
            this.$set(item.tEmptyOutstockSummary, 'tEmptyStockWarehouseList', item.tEmptyStockWarehouseList)
            this.$set(item.tEmptyOutstockSummary, 'whNumber', item.whNumber)
            this.$set(item.tEmptyOutstockSummary, 'whWeight', item.whWeight)
            this.$set(item.tEmptyOutstockSummary, 'waAvNumber', item.waAvNumber)

            dataObj.list.push(item.tEmptyOutstockSummary)

            if (item.flag == '理重') {
              dataObj.sumWeight += item.tEmptyOutstockSummary.weight
            } else {
              dataObj.sumWeight += item.tEmptyOutstockSummary.weighingWeight
            }
            // dataObj.sumWeight = sum
            dataObj.num = item.tEmptyOutstockSummary.number
            mapData.set(cargoControlKey, dataObj)
          }
          const uniqueArr1 = []
          item.tEmptyStockWarehouseList.forEach(item1 => {
            if (!uniqueArr1.some(i => i.warehouseId === item1.warehouseId)) {
              uniqueArr1.push(item1)
            }
          })
          this.$set(item.tEmptyOutstockSummary, 'tEmptyStockWarehouseList', uniqueArr1)
          getEmptyBillStockLocationInfo({
            warehouseId: item.tEmptyOutstockSummary.warehouseId,
            model: item.tEmptyOutstockSummary.model,
            productType: item.tEmptyOutstockSummary.productType,
            specification: item.tEmptyOutstockSummary.specification,
            steelMillName: item.tEmptyOutstockSummary.placeOfOrigin
          }).then(res => {
            item.QuWeiData = []
            // item.tEmptyOutstockSummary.QuWeiData = res
            // that.$set(item1, 'QuWeiData', res)

            const uniqueArr1 = []
            res.forEach(item3 => {
              if (!uniqueArr1.some(i => i.locationId === item3.locationId)) {
                uniqueArr1.push(item3)
              }
            })
            uniqueArr1.forEach((item, index) => {
              if (item.locationId == null) {
                that.$set(item, 'locationName', '无')
              }
            })
            this.$set(item, 'QuWeiData', uniqueArr1)
            console.log(uniqueArr1, 'uniqueArr1')
            this.$set(item.tEmptyOutstockSummary, 'QuWeiData', uniqueArr1)
          }).catch(err => {
            this.$message({
              message: err.message,
              type: 'error'
            })
          })
        }
        this.allDataList = Array.from(mapData.values())
        let sumWeight = this.allDataList[0].sumWeight
        this.$set(this.allDataList[0], 'sumWeight', parseFloat(Number(sumWeight).toFixed(6)))
      } else {
        this.allDataList = []
      }

      let that = this
      for (const item of this.allDataList) {
        item.releaseFlag = 0
        for (let i = 0; i < item.list.length; i++) {
          this.$set(item.list[i], 'jhNumber', item.list[i].number)
          console.log(that.allDataList, 'that.allDataList')
        }
      }
    },
    recursionCheck (index, type) {
      if (index < 0) {
        return
      }
      if (index == this.allDataList.length) {
        this.confirmWhOutstock()
      }
      if (index > this.allDataList.length) {
        // todo
      }
      const item = this.allDataList[index]
      console.log(this.allDataList, 'this.allDataListqwwwww')
      // if (item) {
      if (item.isEnable == '1') {
        // 严控
        if (item.strictReminder == '0') {
          // 控件
          if (item.controlPiece == '1') {
            if (item.num > item.controlStockNumber) {
              this.$message.error((item.cargoControlKey).replace(/,/g, '') + '所输入的件数不能大于未提量')
              this.confirmLoading = false
              return
            }
          }
          if (item.controlWeight == '1') { // 控吨
            if (item.sumWeight > item.controlStockWeight) {
              this.$message.error((item.cargoControlKey).replace(/,/g, '') + '所输入的重量不能大于未提量')
              this.confirmLoading = false
              return
            }
          }
          this.recursionCheck(index + 1, type)
        } else {
          console.log('提示')
          // 提示
          if (item.controlPiece == '1') {
            if (item.num > item.controlStockNumber) {
              this.$message.error((item.cargoControlKey).replace(/,/g, '') + '所输入的件数不能大于未提量')
              this.confirmLoading = false
              return
            }
          }
          // let conFlag = true
          if (item.controlWeight == '1') {
            console.log('控吨')

            if (item.sumWeight > item.controlStockWeight) {
              this.$confirm((item.cargoControlKey).replace(/,/g, '') + '所输入的重量不能大于未提量，是否继续', '提示', {
                confirmButtonText: '继续',
                cancelButtonText: '取消',
                closeOnClickModal: false,
                type: 'warning'
              }).then(() => {
                item.releaseFlag = 1
                this.recursionCheck(index + 1, type)
              }).catch(() => {
                // this.$message.info('出库操作已取消')
              })
            } else {
              this.recursionCheck(index + 1, type)
            }
          } else {
            this.recursionCheck(index + 1, type)
          }
        }
      } else {
        this.confirmWhOutstock()
      }
      // }
    },
    confirmClick (n) {
      // strictReminder 严控：0 或提示：1
      // else if (this.goodArr[i].number>this.goodArr[i].waAvNumber) {
      //     this.$message({
      //       message: '计划件数不能超过仓位可提件数',
      //       type: 'error'
      //     })
      //     return
      //   }
      this.confirmLoading = true
      this.goodArr = []
      this.allDataList.forEach(item => {
        this.goodArr = this.goodArr.concat(item.list)
      })
      for (let i = 0; i < this.goodArr.length; i++) {
        if (this.goodArr[i].number / 1 == 0) {
          this.$message({
            message: '件数不能为空或0',
            type: 'error'
          })
          this.confirmLoading = false
          return
        } else if (this.goodArr[i].warehouseId == '') {
          this.$message({
            message: '仓位不能为空',
            type: 'error'
          })
          this.confirmLoading = false
          return
        } else if (this.goodArr[i].locationId == '') {
          this.$message({
            message: '区位不能为空',
            type: 'error'
          })
          this.confirmLoading = false
          return
        } else if (this.goodArr[i].flag == '磅重' && this.goodArr[i].weighingWeight / 1 == 0) {
          this.$message({
            message: '磅重不能为空或0',
            type: 'error'
          })
          this.confirmLoading = false
          return
        } else if (this.goodArr[i].flag == '磅重' && this.goodArr[i].weighingWeight / 1 !== 0) {
          this.allDataList.forEach((item, index) => {
            // this.$set(item, 'num', item.list.reduce((pre, cur) => { return pre / 1 + cur.number / 1 }, 0))
            this.$set(item, 'sumWeight', (item.list.reduce((pre, cur) => {
              return pre / 1 + cur.allWeight / 1
            }, 0)).toFixed(3))
          })
        }
        if (this.goodArr[i].locationName == '无') {
          this.$set(this.goodArr[i], 'locationName', '')
          this.$set(this.goodArr[i], 'locationId', '')
        }
        if (this.goodArr[i].sceneUser == '') {
          this.$message({
            message: '请选择现场人员！',
            type: 'error'
          })
          this.confirmLoading = false
          return
        }
      }
      this.recursionCheck(0)
      // if (!this.khFlag) {
      //   if (this.allDataList[0].sumWeight > Number(this.controlStockWeight)) { // 有疑问
      //     this.$message({
      //       message: '合计重量不得大于在库控货量',
      //       type: 'error'
      //     })
      //   } else {
      //     this.confirmWhOutstock(n)
      //   }
      // } else {
      //   this.confirmWhOutstock(n)
      // }
      // this.confirmWhOutstock(n)
    },
    // 调接口
    confirmWhOutstock (n) {
      this.confirmLoading = true
      let obj = {
        outstockId: this.tEmptyOutstockMaster.outstockId, // （出库单id  必填）
        outSList: this.goodArr,
        queryList: this.allDataList
      }
      updateTOutstockSummaryZyControl(obj).then(res => {
        this.confirmLoading = false
        this.$emit('update:confirmVisibleThree', false)
        this.$message.success('成功')
        this.$parent.chaxun()
      }).catch(err => {
        this.confirmLoading = false
        this.$message.error(err.message)
      })
    }

  },
  mounted () { }
}

</script>

<style lang="less" scoped>
/deep/.el-table th.star div::before {
  content: '*' !important;
  color: red !important;
}
</style>
